import React, { useEffect, useState } from "react";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    IconButton,
    Typography,
    Tooltip,
    Modal,
    Input,
    Checkbox,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import SvgShare from "../../assets/svg/SvgShare";
import SvgEdit from "../../assets/svg/SvgEdit";
import SvgDelete from "../../assets/svg/SvgDelete";
import config from "../../config";
import Loading from "./Loading";
import ShareComponent from "../../components/ShareComponent/ShareComponent";
import { ToastContainer } from "react-toastify";
import Balls from "./Loading";
import { useNavigate } from "react-router-dom";
import ShareDocumentModal from "../UserDocs/ShareDocumentModal";

const TemplateTable = ({
    isLoading,
    dataToShow,
    renderHighlightedText,
    handleDownload,
    handleQuickView,
    handleRedirectToContract,
    searchText,
    currentPage,
}) => {
    const navigate = useNavigate();
    const [shareModalOpen, setShareModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [files, setFiles] = useState([]);
    const [paginatedFiles, setPaginatedFiles] = useState([]);

    useEffect(() => {
        const paginatedData = dataToShow?.slice((currentPage - 1) * 10, currentPage * 10);
        setPaginatedFiles(paginatedData);
    }, [dataToShow]);
    const handleShareClick = (file) => {
        if (!file) {
            console.error("Selected file is undefined.");
            return;
        }

        // Determine the file URL based on available properties
        const fileUrl = file.fileUrl || file.url;
        if (!fileUrl) {
            console.error("File URL is missing in the selected file.");
            return;
        }

        setSelectedFile({ ...file, fileUrl }); // Set the selected file with its determined file URL
        setShareModalOpen(true);
    };

    const handleCloseModal = () => {
        setShareModalOpen(false);
        setSelectedFile(null); // Clear selected file when closing the modal
    };

    const handleAllDownload = () => {
        if (files.length > 0) {
            files.forEach((file) => handleDownload(file));
        }
    };

    const renderContent = () => {
        const paginatedData = dataToShow?.length > 0 ? dataToShow?.slice((currentPage - 1) * 10, currentPage * 10) : [];
        if (paginatedData.length === 0) {
            return (
                <TableRow>
                    <TableCell colSpan={2} className="table-cell py-4 tw-h-[200px] tw-w-32" sx={{ textAlign: "center" }}>
                        “Oops! No documents match your current filters or search criteria. Please try adjusting your filters or search terms to find
                        relevant results.”
                    </TableCell>
                </TableRow>
            );
        }

        return paginatedData.map((row) => (
            <TableRow key={row.id} className="table-row tw-flex tw-flex-col sm:tw-flex-row tw-border-b-[1px]">
                <div
                    className="tw-w-full sm:tw-w-[65%] tw-p-3 tw-flex tw-gap-2 tw-items-center"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        backgroundColor: "white",
                    }}
                >
                    <Checkbox
                        className="tw-border-none  tw-m-0 tw-p-0 "
                        onChange={(e) => {
                            e.target.checked
                                ? setFiles((prev) => [...prev, { ...row }])
                                : setFiles((prev) => prev.filter((item) => item.id != row.id));
                        }}
                        checked={!!files.find((item) => item.id === row.id)}
                        sx={{
                            "&.Mui-checked": {
                                color: "var(--color-secondary) !important",
                            },
                            ".Mui-focusVisible &": {
                                outline: "2px auto #F2F3F7",
                                outlineOffset: 2,
                            },
                        }}
                        color="default"
                    />
                    <div onClick={() => handleQuickView(row)} className="tw-w-full tw-flex tw-items-center">
                        <Tooltip title={row.name} arrow>
                            <a
                                rel="noopener noreferrer"
                                style={{
                                    textDecoration: "none",
                                    color: "#5D5D5D",
                                    fontSize: window.innerWidth >= 2000 ? "18px" : window.innerWidth <= 640 ? "12px" : "14px",
                                    fontWeight: window.innerWidth >= 2000 ? "700" : "400",
                                    fontFamily: "Roboto",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "inline-block",
                                    maxWidth: window.innerWidth <= 640 ? "200px" : "300px",
                                    cursor: "pointer",
                                }}
                            >
                                <DescriptionIcon sx={{ color: "##333333", marginRight: "0.5rem" }} />
                                {renderHighlightedText(row.name, searchText)}
                            </a>
                        </Tooltip>
                    </div>
                </div>
                <div
                    className="tw-w-full sm:tw-w-[35%] tw-p-3"
                    sx={{
                        textAlign: "start",
                        background: "var(--light-card-fill, rgba(255, 255, 255, 0.34))",
                    }}
                >
                    {files.length == 0 && (
                        <div className="tw-w-full sm:tw-w-fit tw-flex tw-flex-row tw-flex-wrap sm:tw-flex-nowrap tw-gap-2 tw-justify-start sm:tw-justify-start">
                            <Button
                                className="tw-bg-primary hover:tw-bg-primary_hover tw-border-[1px] tw-border-primary"
                                onClick={() => handleDownload(row)}
                                sx={{
                                    fontSize: { xs: "11px", sm: "12px", md: "13px" },
                                    fontWeight: "500",
                                    fontFamily: "Roboto",
                                    color: "white",
                                    borderRadius: "2px",
                                    textTransform: "none",
                                    marginLeft: { xs: 0, sm: "0.6rem" },
                                    height: { xs: "28px", sm: "30px" },
                                    width: { xs: "80px", sm: "90px", md: "103px" },
                                    minWidth: { xs: "70px", sm: "80px" },
                                }}
                            >
                                Download
                            </Button>
                            <Button
                                onClick={() => handleQuickView(row)}
                                sx={{
                                    fontSize: { xs: "11px", sm: "12px", md: "13px" },
                                    fontWeight: "500",
                                    fontFamily: "Roboto",
                                    color: "white",
                                    borderRadius: "2px",
                                    border: "0.5px solid var(--color-tertiary)",
                                    textTransform: "none",
                                    backgroundColor: "var(--color-tertiary)",
                                    marginLeft: { xs: 0, sm: "0.6rem" },
                                    height: { xs: "28px", sm: "30px" },
                                    width: { xs: "85px", sm: "100px", md: "120px" },
                                    minWidth: { xs: "80px", sm: "90px" },
                                    "&:hover": {
                                        backgroundColor: "var(--color-tertiary_hover)",
                                    },
                                }}
                                className="hover:text-black"
                            >
                                Quick View
                            </Button>
                            <IconButton
                                onClick={() => handleShareClick(row)}
                                sx={{
                                    color: "##333333",
                                    marginLeft: { xs: 0, sm: "0.6rem" },
                                    padding: { xs: "4px", sm: "8px" },
                                    "& svg": { fontSize: { xs: "18px", sm: "20px" } },
                                }}
                            >
                                <SvgShare />
                            </IconButton>
                            <IconButton
                                onClick={() => handleRedirectToContract(row)}
                                sx={{
                                    color: "##333333",
                                    marginLeft: { xs: 0, sm: "0.6rem" },
                                    padding: { xs: "4px", sm: "8px" },
                                    "& svg": { fontSize: { xs: "18px", sm: "20px" } },
                                }}
                            >
                                <SvgEdit />
                            </IconButton>
                        </div>
                    )}
                </div>
            </TableRow>
        ));
    };

    return (
        <>
            <>
                <TableContainer className=" " component={Paper} sx={{ borderRadius: "0px", height: "95%" }}>
                    <Table className="tw-h-full " aria-label="simple table" sx={{ backgroundColor: "#FFFFFF57" }}>
                        <TableHead sx={{ backgroundColor: "#F2F3F7" }}>
                            <TableRow className="tw-border-[1px] tw-h-full tw-flex tw-flex-col sm:tw-flex-row tw-justify-between">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "start",
                                        alignItems: "center",
                                        backgroundColor: "#F2F3F7",
                                    }}
                                    className="tw-w-full sm:tw-w-[65%] tw-h-full tw-gap-1 tw-p-3 sm:tw-border-r-[1px] tw-border-[#D0D5DD] tw-flex tw-items-center"
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            backgroundColor: "#F2F3F7",
                                            fontFamily: "Roboto",
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            color: "black",
                                        }}
                                        className="tw-w-fit tw-border-2 tw-border-transparent tw-flex tw-items-center"
                                    >
                                        Documents
                                    </Typography>
                                </div>

                                <div className="tw-w-full sm:tw-w-[35%] tw-p-3 tw-border-none tw-h-fit">
                                    {files.length > 0 ? (
                                        <div className="tw-flex tw-flex-row tw-flex-wrap tw-gap-2 tw-w-full tw-justify-start">
                                            <Button
                                                onClick={() =>
                                                    navigate("/contract-generation/welcome/", {
                                                        state: { documents: files },
                                                    })
                                                }
                                                className="hover:tw-bg-secondary_hover tw-bg-secondary tw-border-[0.5px] tw-border-secondary"
                                                sx={{
                                                    fontSize: { xs: "11px", sm: "12px", md: "13px" },
                                                    fontWeight: "500",
                                                    fontFamily: "Roboto",
                                                    color: "white",
                                                    borderRadius: "2px",
                                                    textTransform: "none",
                                                    height: { xs: "28px", sm: "30px" },
                                                    width: { xs: "100px", sm: "110px", md: "120px" },
                                                    minWidth: { xs: "90px", sm: "100px" },
                                                }}
                                            >
                                                Fill & Sign
                                            </Button>
                                            <Button
                                                onClick={handleAllDownload}
                                                sx={{
                                                    fontSize: { xs: "11px", sm: "12px", md: "13px" },
                                                    fontWeight: "500",
                                                    fontFamily: "Roboto",
                                                    color: "white",
                                                    borderRadius: "2px",
                                                    textTransform: "none",
                                                    height: { xs: "28px", sm: "30px" },
                                                    width: { xs: "100px", sm: "110px", md: "120px" },
                                                    minWidth: { xs: "90px", sm: "100px" },
                                                    "&:hover": {
                                                        color: "black",
                                                    },
                                                }}
                                                className="hover:text-white tw-bg-primary hover:tw-bg-primary_hover tw-border-[1px] tw-border-primary"
                                            >
                                                Download
                                            </Button>
                                        </div>
                                    ) : (
                                        <Typography
                                            variant="body2"
                                            className="tw-w-fit tw-border-none tw-flex tw-items-center  tw-h-full"
                                            sx={{
                                                fontFamily: "Roboto",
                                                fontSize: "16px",
                                                fontWeight: "700",
                                                // textAlign: "center",
                                                color: "black",
                                                backgroundColor: "#F2F3F7",
                                            }}
                                        >
                                            Action
                                        </Typography>
                                    )}
                                </div>
                            </TableRow>
                        </TableHead>
                        {isLoading ? (
                            <TableBody>
                                <TableRow className="">
                                    <div
                                        className="  py-4 tw-h-[300px] tw-w-full tw-flex tw-justify-center tw-items-center                                    "
                                        sx={{ textAlign: "center" }}
                                    >
                                        <Balls />
                                    </div>
                                    {/* <TableCell></TableCell> */}
                                </TableRow>
                            </TableBody>
                        ) : (
                            // <div className="tw-w-full tw-flex tw-justify-center  tw-h-[400px] tw-border-red-500 tw-border-2">

                            // </div>
                            <TableBody sx={{ height: "100%" }}>{renderContent()}</TableBody>
                        )}
                    </Table>
                </TableContainer>
                {/* Wrap ShareComponent in a Modal */}
                <Modal open={shareModalOpen} onClose={handleCloseModal}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: { xs: "90%", sm: "80%", md: 700 },
                            maxWidth: "90vw",
                            maxHeight: "90vh",
                            padding: 2,
                            backgroundColor: "white",
                            borderRadius: "8px",
                            boxShadow: 24,
                            overflow: "auto",
                            outline: "none",
                        }}
                    >
                        <ShareDocumentModal selectedFile={selectedFile} onClose={handleCloseModal} />
                    </Box>
                </Modal>
            </>
        </>
    );
};

export default TemplateTable;
